<template>
    <CardContentPanel icon="file-check" v-bind="{action, index}">
        <template #title>{{ $t('projectclient.projectview.activity.pending.actions.CONFIRM_MISCLASSIFICATION_GUIDELINE.title') }}</template>
        <template #body>
            {{ $t('projectclient.projectview.activity.pending.actions.CONFIRM_MISCLASSIFICATION_GUIDELINE.description') }}
        </template>
        <template #actions>
            <VJoyButton variant="main" size="small" :disabled="showFunnel" data-testid="pending-action-card-cta-primary" @click="showFunnel = true">
                {{ $t('projectclient.projectview.activity.pending.actions.CONFIRM_MISCLASSIFICATION_GUIDELINE.action.primary') }}
            </VJoyButton>
        </template>
    </CardContentPanel>

    <InjectMicroFrontendApp
        app="compliance-mf-misclassification-guidelines"
        :props="{guidelineId: props.action.extraData.guidelineId, organizationId: props.action.extraData.organizationId, open: showFunnel}"
        @misclassification-guidelines-confirmed="onConfirmed"
        @misclassification-guidelines-cancelled="showFunnel = false"
    />
</template>

<script setup lang="ts">
    import {ref} from 'vue';
    import {InjectMicroFrontendApp} from '#components';
    import {VJoyButton} from '@maltjoy/core-vue';
    import CardContentPanel from '../CardContentPanel.vue';
    import type {ActivityPendingActionByType} from '@/features/project-view';
    import {useActivityStore} from '@/features/project-view';

    const props = defineProps<{
        action: ActivityPendingActionByType<'CONFIRM_MISCLASSIFICATION_GUIDELINE'>;
        index: number;
    }>();

    const activityStore = useActivityStore();
    const showFunnel = ref(false);

    function onConfirmed() {
        showFunnel.value = false;
        activityStore.fetchProjectActivity();
    }
</script>
